import { render, staticRenderFns } from "./CmgRewardsList.vue?vue&type=template&id=f912b41a&scoped=true&lang=pug"
import script from "./cmg-rewards-list.ts?vue&type=script&lang=ts&external"
export * from "./cmg-rewards-list.ts?vue&type=script&lang=ts&external"
import style0 from "./CmgRewardsList.vue?vue&type=style&index=0&id=f912b41a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f912b41a",
  null
  
)

export default component.exports